import { useMemo } from "react";
import { FlueDao } from "./FlueDao";

export const useFlueDao = (environment: string): FlueDao => {
  //const accessToken = useAccessToken();

  return useMemo(() => new FlueDao(environment), [environment]);
};
